export class FolderRenameTabRequestEvent {
    public constructor(
        public folderId: string,
        public folderName: string
    ) {}
}
